import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorBaseComponent } from '../error-base/error-base.component';

@Component({
  selector: 'app-bad-request',
  templateUrl: './400.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ErrorBaseComponent],
})
export class BadRequestComponent {
  public errorUrl = '';

  constructor(private readonly router: Router) {
    const navigation = this.router.currentNavigation();
    // errorUrl param sent from the error.interceptor
    this.errorUrl = navigation?.extras?.state?.errorUrl;
  }
}
